export const paymentLinksListPath = "/payment-links";
export const paymentLinksListUrl = paymentLinksListPath;
